import { useState } from 'react'
import { SxProps, Theme, useMediaQuery } from '@mui/material'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'

interface TabItem {
  label: string
  element: React.ReactNode
  width?: string
}

interface Props {
  list: TabItem[]
  styleTabs?: SxProps<Theme>
}

export default function CustomTabs({ list, styleTabs }: Props) {
  const [selectedTab, setSelectedTab] = useState(0)
  const isMobile = useMediaQuery('(max-width:800px)')

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  // Calculate responsive tab width
  const getTabWidth = (tab: TabItem) => {
    if (isMobile) {
      // On mobile, let tabs be flexible with minimum width
      return {
        minWidth: '80px',
        maxWidth: `${100 / list.length}%`,
        flex: 1,
      }
    }
    // On desktop, use original width or default
    return { width: tab.width || 'auto' }
  }

  return (
    <Box sx={{}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', ...styleTabs }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label='custom tabs'
          indicatorColor='secondary'
          variant={isMobile ? 'scrollable' : 'standard'}
          scrollButtons={isMobile ? 'auto' : false}
          allowScrollButtonsMobile={true}
          sx={{
            '& .MuiTabs-indicator': {
              height: '5px',
            },
            '& .MuiTabs-scrollButtons': {
              color: 'primary.main',
            },
          }}
        >
          {list.map((tab, index) => (
            <Tab
              label={tab.label}
              key={`${tab.label}-${index}`}
              sx={{
                letterSpacing: '1px',
                fontWeight: '700',
                color: 'primary.main',
                textTransform: 'none',
                fontSize: isMobile ? '0.875rem' : '1rem',
                padding: isMobile ? '8px 12px' : '12px 16px',
                minHeight: isMobile ? '44px' : '48px',
                ...getTabWidth(tab),
                '&.Mui-selected': {
                  fontWeight: '800',
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {list.map((item, index) => (
        <div hidden={index !== selectedTab} key={`${item.label}-content-${index}`}>
          {item.element}
        </div>
      ))}
    </Box>
  )
}
